module.exports = __webpack_public_path__ + "media/images/referrals/card-with-lock-1d685ddc99e3048b016903f04939ece2.png";